// extracted by mini-css-extract-plugin
module.exports = {"GenericListItem":"GenericList_GenericListItem__3VpTa","ListContainer":"GenericList_ListContainer__BT4nF"};